import React from 'react'
import CollectionsDashboard from '../../../../Collections/CollectionsDashboard/CollectionsDashboard'

export default function DriverCollectionsTab({ driverPk }) {
    if (!driverPk) return null
    return <CollectionsDashboard lockedDriverId={driverPk} />
}
